export const REPLY_DRAFT_PREFIX = 'truxsocial:reply-draft:';
export function clearReplyDrafts(keepOwner?: string) {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(REPLY_DRAFT_PREFIX) && (!keepOwner || !key.startsWith(`${REPLY_DRAFT_PREFIX}${keepOwner}:`))) sessionStorage.removeItem(key);
    }
  } catch {
    /* storage is optional */
  }
}
